import { Jiffy } from "@green24/npm-javascript-utils";

export const APP_CONSTANTS = {
	LOCATION_UPDATE_TIME: Jiffy.formatToMs("1m"),
	LOCAL_STORAGE_NO_REDIRECT_EVENT_NAME: "no-redirect-storage-update",
	ROUTE_UPDATE_EVENT_NAME: "route-update",
	IDLE_RESET: "idle-reset",
	DISPLAY_UPDATE: "display-update",
	LOCAL_STORAGE_TOKEN_KEY: "token",
	LOCAL_STORAGE_SIMULATE_PAYMENT_PROCESS: "simulatePaymentProcess",
	LOCAL_STORAGE_SIMULATE_WIZARD_SESSION_CREATION: "simulateRentWizardSessionCreation",
	LOCAL_STORAGE_SIMULATE_BOX_OPENING: "simulateBoxOpening",
};
